import { useCallback, useEffect } from "react";
import { KEYBOARD_KEYS } from "../constants";
/**
 * Execute a callback on Escape.
 *
 * @param {Function} callback A function to execute on Escape
 * @param {Boolean} active A boolean indicating if this hook is active
 */

export default function useOnEscape(handler, active) {
  const onKeyUp = useCallback(event => {
    if (event.key === KEYBOARD_KEYS.ESCAPE) {
      handler(event, KEYBOARD_KEYS.ESCAPE);
    }
  }, [handler]);
  useEffect(() => {
    if (active) {
      document.addEventListener("keyup", onKeyUp);
      return () => {
        document.removeEventListener("keyup", onKeyUp);
      };
    }
  }, [active, onKeyUp]);
}